export const REDEEM_RIDDLE_CHALLENGE_PERSISTENCE_KEY = 'redeem_riddle_challenge';
export const FIFTEEN_MINUTES_IN_SECONDS = 15 * 60;
